module.exports = __webpack_public_path__ + "static/media/email.0eaae797.svg";